import TextField from '@/common/components/TextField'
import { SpecialEntriesData } from '@/features/companies/types/companies.type'
import { ModalDeleteSpecialEntry } from '@/features/privateCompanies/components/SpecialEntries/ModalDeleteSpecialEntry'
import { ShowEntryTextField } from '@/features/privateCompanies/components/SpecialEntries/ShowEntryTextField'

interface SpecialEntryItemProps {
  specialEntry: SpecialEntriesData
  disabled?: boolean
}

export const SpecialEntryItem = ({ specialEntry, disabled }: SpecialEntryItemProps) => {
  return (
    <div key={specialEntry.id} className="space-y-4">
      <div className="flex gap-2">
        <ModalDeleteSpecialEntry specialEntryId={specialEntry.id} disabled={disabled} />

        <TextField
          label="Estabelecimento"
          value={
            specialEntry.target === null
              ? 'Todos os estabelecimentos'
              : `${specialEntry.target.general_information?.fantasy_name} (${specialEntry.target.general_information?.official_name})`
          }
          disabled
          className="w-full"
        />
      </div>

      <div className="flex gap-2">
        <TextField label="Tarifa" value={specialEntry.fee_template?.display_name} disabled className="w-full" />

        <ShowEntryTextField specialEntry={specialEntry} className="w-full" />
      </div>
    </div>
  )
}
